export const RGB_BLACK = 'rgb(0, 0, 0)';
export const RGBA_TRANSPARENT = 'rgba(0, 0, 0, 0)';
export const NONE_COLOR = '';
